import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateSettings,
  selectSettings,
  clearAuthError,
} from 'store/slices/authSlice';
import {
  TIMEZONE_OPTIONS,
  DATE_FORMATS_OPTIONS,
  TIME_FORMATS_OPTIONS,
  START_OF_WEEK_OPTIONS,
} from 'constants/date';
import { SelectField } from 'components/forms';
import Page from 'components/layout/Page/Page';
import SettingsWrapper from './components/SettingsWrapper/SettingsWrapper';
import SettingsItem from './components/SettingsItem/SettingsItem';

import SettingsSection from './components/SettingsSection/SettingsSection';

export default function Settings() {
  const dispatch = useDispatch();
  const settings = useSelector(selectSettings);
  const { user, loading, error, status } = useSelector((state) => state.auth); // Fix duplicate declaration
  useEffect(() => {
    return () => {
      dispatch(clearAuthError());
    };
  }, [dispatch]);

  const handleUpdate = (key, value) => {
    if (user?.id) {
      dispatch(updateSettings({
        userId: user.id,
        settings: { ...settings, [key]: value }
      }));
    }
  };

  return (
    <Page title="Settings">
      <SettingsWrapper>
        <SettingsSection 
          title="Regional Preferences" 
          description="Customize how dates and times are displayed across your account."
          status={status}
          error={error}
          onAlertClose={() => dispatch(clearAuthError())}
        >
          <SettingsItem
            label="Timezone"
            value={settings?.timezone || ''}
            displayValue={TIMEZONE_OPTIONS.find(opt => opt.value === settings?.timezone)?.label}
            onUpdate={(val) => handleUpdate('timezone', val)}
            loading={loading}
          >
            {({ value, onChange }) => (
              <SelectField
                value={value}
                onChange={onChange}
                options={TIMEZONE_OPTIONS}
                className="w-full"
              />
            )}
          </SettingsItem>

          <SettingsItem
            label="Date Format"
            value={settings?.dateFormat || ''}
            displayValue={DATE_FORMATS_OPTIONS.find(opt => opt.value === settings?.dateFormat)?.label}
            onUpdate={(val) => handleUpdate('dateFormat', val)}
            loading={loading}
          >
            {({ value, onChange }) => (
              <SelectField
                value={value}
                onChange={onChange}
                options={DATE_FORMATS_OPTIONS}
                className="w-full"
              />
            )}
          </SettingsItem>

          <SettingsItem
            label="Time Format"
            value={settings?.timeFormat || ''}
            displayValue={TIME_FORMATS_OPTIONS.find(opt => opt.value === settings?.timeFormat)?.label}
            onUpdate={(val) => handleUpdate('timeFormat', val)}
            loading={loading}
          >
            {({ value, onChange }) => (
              <SelectField
                value={value}
                onChange={onChange}
                options={TIME_FORMATS_OPTIONS}
                className="w-full"
              />
            )}
          </SettingsItem>

          <SettingsItem
            label="Start of Week"
            value={settings?.startOfWeek || ''}
            displayValue={START_OF_WEEK_OPTIONS.find(opt => opt.value === settings?.startOfWeek)?.label}
            onUpdate={(val) => handleUpdate('startOfWeek', val)}
            loading={loading}
          >
            {({ value, onChange }) => (
              <SelectField
                value={value}
                onChange={onChange}
                options={START_OF_WEEK_OPTIONS}
                className="w-full"
              />
            )}
          </SettingsItem>
        </SettingsSection>
      </SettingsWrapper>
    </Page>
  );
}
